<template>
    <div class="main">
      <software-list :url="url"></software-list>
    </div>
</template>

<script>
   import softwareList from './softwareList.vue'

  export default {
    name: "software",
    data() {
      return {
        url:'software'
      }
    },
    components:{softwareList},
    created: function () {
      sessionStorage.removeItem('tutorialHover');
    },
    methods: {

    }
  }
</script>

<style scoped lang="less">
  .main {
    width: 1170px;
    margin: auto auto 15px auto;
    min-height: calc(100% - 486px);
  }

  @media screen and (max-width: 1024px) {
    .main {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/software.vue